// extracted by mini-css-extract-plugin
export var SearchResult = "SearchResult-module--SearchResult--3mHaJ";
export var SearchResultTitle = "SearchResult-module--SearchResultTitle--2IVaF";
export var SearchResultLink = "SearchResult-module--SearchResultLink---o44Z";